import { render, staticRenderFns } from "./PlumberOrderDetail.vue?vue&type=template&id=df131c4a&scoped=true"
import script from "./PlumberOrderDetail.vue?vue&type=script&lang=js"
export * from "./PlumberOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./PlumberOrderDetail.vue?vue&type=style&index=0&id=df131c4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df131c4a",
  null
  
)

export default component.exports